(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-bundle-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.tfReady) return;
    var thumbs = [].slice.call(root.querySelectorAll('.tf-g-thumb'));
    if (!thumbs.length) return; // no images yet: leave the native gallery in place
    root.dataset.tfReady = '1';

    var stage = root.querySelector('.tf-bg__stage');
    var main = root.querySelector('.tf-bg__main');
    var thumbsWrap = root.querySelector('.tf-bg__thumbs');
    var prev = root.querySelector('.tf-bg__arrow--prev');
    var next = root.querySelector('.tf-bg__arrow--next');
    var zoomBtn = root.querySelector('.tf-bg__zoom');
    var defaultPlan = root.dataset.defaultPlan || '12-month';
    var plan = window.__tfSelectedPlan || defaultPlan;
    var current = null, lb = null;

    function visible(p) {
      return thumbs.filter(function (t) { return (' ' + t.dataset.plans + ' ').indexOf(' ' + p + ' ') !== -1; });
    }
    function setMain(t) {
      if (!t) return;
      current = t;
      main.src = t.dataset.full;
      if (t.dataset.srcset) main.setAttribute('srcset', t.dataset.srcset); else main.removeAttribute('srcset');
      main.alt = t.dataset.alt || '';
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      try { t.scrollIntoView({ inline: 'nearest', block: 'nearest' }); } catch (e) {}
    }
    function render(p) {
      plan = p;
      var vis = visible(p);
      thumbs.forEach(function (t) { t.hidden = vis.indexOf(t) === -1; });
      root.classList.toggle('tf-bg--multi', vis.length > 1);
      if (!vis.length) { stage.style.visibility = 'hidden'; thumbsWrap.style.display = 'none'; return; }
      stage.style.visibility = ''; thumbsWrap.style.display = vis.length > 1 ? '' : 'none';
      setMain(current && vis.indexOf(current) !== -1 ? current : vis[0]);
    }
    function step(d) {
      var vis = visible(plan);
      if (vis.length < 2) return;
      var i = vis.indexOf(current); if (i < 0) i = 0;
      setMain(vis[(i + d + vis.length) % vis.length]);
    }
    function openZoom() {
      if (!current) return;
      if (!lb) {
        lb = document.createElement('div'); lb.className = 'tf-bg-lightbox';
        lb.innerHTML = '<button class="tf-bg-lightbox__x" type="button" aria-label="Close">\u2715</button><img class="tf-bg-lightbox__img" alt="">';
        document.body.appendChild(lb);
        function close() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.tf-bg-lightbox__x')) close(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
      }
      lb.querySelector('.tf-bg-lightbox__img').src = current.dataset.full;
      lb.classList.add('is-open'); document.body.style.overflow = 'hidden';
    }

    thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(t); }); });
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (!tracking) return; tracking = false; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1); }, { passive: true });

    if (zoomBtn) {
      stage.style.cursor = 'zoom-in';
      zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); openZoom(); });
      stage.addEventListener('click', function (e) { if (e.target.closest('.tf-bg__arrow') || e.target.closest('.tf-bg__zoom')) return; openZoom(); });
    }

    document.addEventListener('tf:plan', function (e) { var p = e && e.detail && e.detail.plan; if (p) render(p); });

    mount(root);
    render(plan);
  }

  function mount(root) {
    if (root.dataset.tfMounted) return;
    var native = document.querySelector('media-gallery');
    if (!native) {
      root.__t = (root.__t || 0) + 1;
      if (root.__t < 50) setTimeout(function () { mount(root); }, 80);
      return;
    }
    [].forEach.call(document.querySelectorAll('.tf-bg[data-tf-mounted]'), function (g) { if (g !== root && g.parentNode) g.parentNode.removeChild(g); });
    root.dataset.tfMounted = '1';
    native.parentNode.insertBefore(root, native);
    native.style.display = 'none';
    native.setAttribute('data-tf-replaced', '1');
    window.__tfBundleGalleryActive = true;
  }

  function initAll() { [].forEach.call(document.querySelectorAll('.tf-bg'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-jump-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(bar) {
    if (bar.dataset.tfReady) return;
    var target = document.querySelector(bar.dataset.target) || document.querySelector('#tf-root');
    var appear = document.querySelector(bar.dataset.appear) || target;
    if (!target || !appear) {
      bar.__t = (bar.__t || 0) + 1;
      if (bar.__t < 50) setTimeout(function () { init(bar); }, 100);
      return;
    }
    bar.dataset.tfReady = '1';
    var offset = parseInt(bar.dataset.offset, 10) || 80;

    // Show once the shopper reaches the appear section (the FAQ by default) and while at or below it.
    function update(en) { bar.classList.toggle('is-visible', en.isIntersecting || en.boundingClientRect.top < 0); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { entries.forEach(update); }, { threshold: 0 });
      io.observe(appear);
    } else {
      var onScroll = function () { bar.classList.toggle('is-visible', appear.getBoundingClientRect().top < window.innerHeight); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    bar.addEventListener('click', function () {
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    });
  }
  function initAll() { [].forEach.call(document.querySelectorAll('.tf-jump'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-promo-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function relocate(bar) {
    // Some themes wrap page content in an element with a CSS transform/filter,
    // which silently breaks position:fixed (the bar sticks to that wrapper,
    // not the viewport). Moving it to <body> guarantees viewport pinning.
    if (bar.dataset.tfMoved) return;
    var i, els = document.querySelectorAll('.tf-promo');
    for (i = 0; i < els.length; i++) {
      // Drop a stale twin left in <body> after a theme-editor section reload.
      if (els[i] !== bar && els[i].id === bar.id && els[i].parentNode === document.body) {
        els[i].parentNode.removeChild(els[i]);
      }
    }
    document.body.appendChild(bar);
    bar.dataset.tfMoved = '1';
  }
  function init(bar) {
    relocate(bar);
    if (bar.dataset.tfReady) return; bar.dataset.tfReady = '1';
    var appear = parseInt(bar.dataset.appear, 10) || 0;
    if (appear > 0) {
      var onScroll = function () { bar.classList.toggle('is-visible', window.pageYOffset > appear); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    }
  }
  function initAll() { [].forEach.call(document.querySelectorAll('.tf-promo'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
